import styled from 'styled-components';

type MarginProps = {
  $bottomMargin: boolean;
};

export const Root = styled.div<MarginProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: ${({ $bottomMargin }) => ($bottomMargin ? '20px' : '0')};
`;

export const ContentContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 16px;
`;

export const LeftColumn = styled.div`
  flex: 1;
  display: flex;
`;

export const RightColumn = styled.div`
  flex: 1;
  text-align: right;

  > button {
    padding: 0 8px 16px;
  }
`;

export const NavButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 20px;
    margin-right: 8px;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const Title = styled.h3`
  color: ${({ theme }) => theme.colors.grey5};
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  margin: 0;
`;

export const Divider = styled.div`
  height: 0;
  width: 100%;
  border: none;
  border-top: 1px solid ${({ theme }) => theme.colors.grey3};
`;
